export default __webpack_public_path__ + "static/media/logo-batik.c5f30d00.png";